"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVaccinationDto = instanceOfVaccinationDto;
exports.VaccinationDtoFromJSON = VaccinationDtoFromJSON;
exports.VaccinationDtoFromJSONTyped = VaccinationDtoFromJSONTyped;
exports.VaccinationDtoToJSON = VaccinationDtoToJSON;
exports.VaccinationDtoToJSONTyped = VaccinationDtoToJSONTyped;
const VaccinationType_1 = require("./VaccinationType");
const VaccinationDoseDto_1 = require("./VaccinationDoseDto");
/**
 * Check if a given object implements the VaccinationDto interface.
 */
function instanceOfVaccinationDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('doses' in value) || value['doses'] === undefined)
        return false;
    return true;
}
function VaccinationDtoFromJSON(json) {
    return VaccinationDtoFromJSONTyped(json, false);
}
function VaccinationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'code': (0, VaccinationType_1.VaccinationTypeFromJSON)(json['code']),
        'completed': json['completed'] == null ? undefined : json['completed'],
        'doses': (json['doses'].map(VaccinationDoseDto_1.VaccinationDoseDtoFromJSON)),
        'hasTiter': json['hasTiter'] == null ? undefined : json['hasTiter'],
        'document': json['document'] == null ? undefined : json['document'],
        'declinationDate': json['declinationDate'] == null ? undefined : (new Date(json['declinationDate'])),
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
        'storedDocumentId': json['storedDocumentId'] == null ? undefined : json['storedDocumentId'],
        'storedDocumentMimeType': json['storedDocumentMimeType'] == null ? undefined : json['storedDocumentMimeType'],
    };
}
function VaccinationDtoToJSON(json) {
    return VaccinationDtoToJSONTyped(json, false);
}
function VaccinationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'code': (0, VaccinationType_1.VaccinationTypeToJSON)(value['code']),
        'completed': value['completed'],
        'doses': (value['doses'].map(VaccinationDoseDto_1.VaccinationDoseDtoToJSON)),
        'hasTiter': value['hasTiter'],
        'document': value['document'],
        'declinationDate': value['declinationDate'] == null ? undefined : (value['declinationDate'].toISOString()),
        'expiresAt': value['expiresAt'] == null ? undefined : (value['expiresAt'].toISOString()),
        'storedDocumentId': value['storedDocumentId'],
        'storedDocumentMimeType': value['storedDocumentMimeType'],
    };
}
//# sourceMappingURL=VaccinationDto.js.map